import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';

import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Store
import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

// Types
import User from '@common/types/user/user';

// Components
import NewMenu from '@components/new-menu';
import Typography from '@components/basics/typography';

// Controllers
import UserAvatarInfo from '@components/basics/user-avatar-info';
import DefaultAvatar from '@components/basics/default-avatar';

interface VerificationTrialMenuProps extends Partial<User> {
  className?: string;
  button: React.ReactNode;
  noButton?: boolean;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  avatar: state.artist.active?.avatar,
  fullName: state.artist.active?.name,
  isMobile: state.ui.mobile,
});

const VerificationTrialMenu: FunctionComponent<VerificationTrialMenuProps> = ({
  className,
  button,
  noButton,
  avatar,
  fullName,
  isMobile,
}) => {
  return (
    <NewMenu
      className={className}
      button={noButton ? undefined : button}
      noButton={noButton}
      menuId="VERIFICATION_MENU"
      centeredPadding={!isMobile}
      topHeader={isMobile && <UserAvatarInfo src={avatar} name={fullName!} />}
      header={!isMobile && <UserAvatarInfo src={avatar} name={fullName!} />}
    >
      {avatar ? (
        <CircleAvatar src={avatar} alt={fullName} />
      ) : (
        <StyledDefaultAvatar />
      )}
      <VerificationBadge src="./static/verification-badge.png" />
      <Typography
        className="mb-40"
        type="analytics-nav"
        customFont="semi-bold"
        align={'center'}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.TITLE" />
      </Typography>
      <MenuTypography className="mb-40" align={'left'}>
        <Translate id="DASHBOARD.VERIFICATION_MENU.TEXT1" />
      </MenuTypography>

      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '3px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP1.PART1" />
        <Link
          style={{ textDecoration: 'underline' }}
          to={{ pathname: 'https://artists.spotify.com/home' }}
          target="_blank"
        >
          <Translate id="DASHBOARD.VERIFICATION_MENU.STEP1.PART2" />
        </Link>
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP1.PART3" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '3px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP2" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '3px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP3" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '3px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP4" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '3px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP5" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '3px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP6.PART1" />
        <Link
          style={{ textDecoration: 'underline' }}
          to={{ pathname: 'mailto:spotify@trac.co' }}
          target="_blank"
        >
          <Translate id="DASHBOARD.VERIFICATION_MENU.STEP6.PART2" />
        </Link>
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP6.PART3" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginBottom: '0px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.STEP7" />
      </MenuTypography>
      <MenuTypography
        className="mb-40"
        align={'left'}
        style={{ marginTop: '20px' }}
      >
        <Translate id="DASHBOARD.VERIFICATION_MENU.TEXT2" />
      </MenuTypography>
    </NewMenu>
  );
};

export default connect(mapStateToProps)(VerificationTrialMenu);
const CircleAvatar = styled.img`
  width: 116px;
  height: 116px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  margin: 0 auto 32px;
`;

const StyledDefaultAvatar = styled(DefaultAvatar)`
  width: 116px;
  height: 116px;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  margin: 0 auto 32px;
`;
const VerificationBadge = styled.img`
  display: block;
  left: 53%;
  position: relative;
  top: -75px;
`;

const MenuTypography = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.h4};
`;
